export enum AppRoles {
  RESELLER_ADMIN = 'RESELLER_ADMIN',
  RESELLER_FINANCE = 'RESELLER_FINANCE',
  RESELLER_ORDER = 'RESELLER_ORDER',
  RESELLER_SERVICE_DESK = 'RESELLER_SERVICE_DESK',
}
